import { Component } from '@angular/core';

@Component({
    selector: 'red-pencil-character',
    templateUrl: '../../../../../../src/assets/svgs/characters/redpencil.svg',
    styleUrls: ['../svg.component.scss']
})
export class RedPencilCharacter {

}